<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
      <div class="d-grid grid-columns-top-3">
        <div class="accounts">
          <ul>
            <li></li>
            <li></li>
          </ul>
        </div>
        <div class="search">
          <form action="search-results.html" method="get">
            <input id="search" name="search" type="text" [(ngModel)]="concode" (keyup) = "retriveContactsLookup()"
              placeholder="Contact ID">
            <label>                      </label>
            <input id="search" name="search" type="text" [(ngModel)]="conaname" (keyup)="retriveContactsLookup()"
              placeholder="Contact Name">

          </form>
        </div>
      </div>
    </div>
  </section>

  <table>
    <thead>
      <tr>
        <th style="width: 30%;">Contact ID</th>
        <th style="width: 100%;">Contact Name</th>
        <th style="width: 20%;">Choose</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let Do of ContactsList; let i = index">
        <td data-column="Doctor ID">{{Do.concode}}</td>
        <td data-column="Doctor Name">{{Do.conaname}}</td>

        <td data-column="Choose"><button type="button" class="theme-button btn" id="select" name="select"
            (click)="SelectContacts(Do)">Select</button>
        </td>
      </tr>

    </tbody>
  </table>
</mat-dialog-content>


